import { Button, useModalContext } from '~/common/components';
import { cx } from '~/common/utils';
import { authProviders } from '~/images/Brands';
import { useOauthLogin } from '~/root/Auth';
import { SignupConsentModal } from './SignupConsentModal';
import css from './OauthProviders.module.scss';

export const OauthProviders = ({
  className,
  inline = false,
  isSignup = false,
}: {
  className?: string;
  inline?: boolean;
  isSignup?: boolean;
}) => {
  const { mutateAsync, isLoading } = useOauthLogin();
  const modals = useModalContext();

  const onSignupClick = (provider: Provider) =>
    modals.open(SignupConsentModal, {
      onSubmit: (news_letter?: boolean) => mutateAsync({ provider, news_letter, action: 'signup' }),
    })();

  const onLoginClick = (provider: Provider) => mutateAsync({ provider, action: 'login' });

  const onProviderClick = isSignup ? onSignupClick : onLoginClick;

  return (
    <div className={cx('space-y-3 font-brand-b3', className)}>
      <div className={cx('flex', inline ? 'smo:flex-col gap-3 smo:gap-2' : 'flex-col gap-3')}>
        {authServicesContent.map(({ id: provider, name, icon }) => (
          <Button.Base
            key={provider}
            disabled={isLoading}
            className="flex items-center gap-2 text-primary-300 border border-other-400 rounded w-full h-6 px-[12px]"
            onClick={() => onProviderClick(provider)}
          >
            <img src={icon} alt={name} />
            Continue with {name}
          </Button.Base>
        ))}
      </div>
      <div
        className={cx(
          css.divider,
          'relative text-center font-brand-b3',
          inline && 'before:w-[45%] after:w-[45%]',
        )}
      >
        or
      </div>
    </div>
  );
};

type Provider = 'google' | 'microsoft';
type AuthServicesContent = { id: Provider; name: string; icon: string };

const authServicesContent = [
  {
    id: 'google',
    name: 'Google',
    icon: authProviders.google,
  },
  {
    id: 'microsoft',
    name: 'Microsoft',
    icon: authProviders.microsoft,
  },
] satisfies AuthServicesContent[];
